export default __webpack_public_path__ + "static/media/hub.642eb4cc.png";